import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { LEARN_MODULES } from "@/data/learn";

export default function Learn() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-16" data-testid="learn-page">
      <div className="max-w-3xl">
        <p className="eyebrow">Sip Alchemy · 101</p>
        <h1 className="mt-2 font-serif-display text-4xl sm:text-5xl md:text-6xl font-bold text-cream leading-[1.05]">
          The library, for<br /><span className="italic font-serif-editor text-pink-brand">the merely curious.</span>
        </h1>
        <p className="mt-4 text-cream/70 font-body max-w-2xl">
          Seven short reads to sound smarter, drink better, and finally understand what everyone at the bar is talking about.
        </p>
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
        {LEARN_MODULES.map((m, i) => (
          <Link
            to={`/learn/${m.slug}`}
            key={m.slug}
            className="card-cream overflow-hidden group flex flex-col"
            data-testid={`learn-card-${m.slug}`}
          >
            <div className="aspect-[16/9] overflow-hidden">
              <img src={m.image} alt={m.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-6 flex-1 flex flex-col">
              <span className="chip chip-pink w-fit">#{String(i + 1).padStart(2, "0")}</span>
              <p className="mt-3 font-serif-display text-2xl font-bold text-cream leading-snug">{m.title}</p>
              <p className="mt-2 text-sm text-cream/60 font-body">{m.excerpt}</p>
              <div className="mt-auto pt-5 flex items-center justify-between text-sm text-cream/60">
                <span className="inline-flex items-center gap-1"><Clock size={14} /> {m.read} read</span>
                <span className="inline-flex items-center gap-1 text-pink-brand font-semibold">Read <ArrowRight size={14} /></span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
